/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Table: {
        $top: implementRelation({
            kind: 'direct',
            target: 'Top',
            field: 'topId',
            cardinality: '1-1'
        }),
        $base: implementRelation({
            kind: 'direct',
            target: 'Base',
            field: 'baseStyleId',
            cardinality: '1-1'
        }),
        $bench: implementRelation({
            kind: 'direct',
            target: 'Bench',
            field: 'benchId',
            cardinality: '1-1'
        })
    },
    Top: {
        $table: implementRelation({
            kind: 'indirect',
            target: 'Table',
            field: 'topId',
            cardinality: '1-1'
        }),
        $apron: implementRelation({
            kind: 'direct',
            target: 'Apron',
            field: 'apronId',
            cardinality: '1-1'
        })
    },
    Base: {
        $table: implementRelation({
            kind: 'indirect',
            target: 'Table',
            field: 'baseStyleId',
            cardinality: '1-1'
        })
    },
    Bench: {
        $table: implementRelation({
            kind: 'indirect',
            target: 'Table',
            field: 'benchId',
            cardinality: '1-1'
        })
    },
    Apron: {
        $top: implementRelation({
            kind: 'indirect',
            target: 'Top',
            field: 'apronId',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {
    Base: {
        customBaseFinishNeedsPersonalizedQuote: {
            type: 'customBaseFinishNeedsPersonalizedQuote',
            severity: 'notice',
            message: {
                id: "TwUpew",
                message: "Custom base finish"
            }
        },
        baseFourLegMustHaveAprons: {
            type: 'baseFourLegMustHaveAprons',
            severity: 'fatal',
            message: {
                id: "hBoR1I",
                message: "Four leg bases must have an apron"
            }
        },
        supportsCrossbrace: {
            type: 'supportsCrossbrace',
            severity: 'fatal',
            message: {
                id: "IE18uv",
                message: "This Base does not support a crossbrace"
            }
        }
    },
    Table: {
        seatingAmountNotAvailableForThisSeatingType: {
            type: 'seatingAmountNotAvailableForThisSeatingType',
            severity: 'fatal',
            message: {
                id: "kKkSlf",
                message: "Seating Amount cannot be applied for this Seating Type"
            }
        }
    },
    Top: {
        lengthLargerThanWidth: {
            type: 'lengthLargerThanWidth',
            severity: 'fatal',
            message: {
                id: "ylhfpt",
                message: "Length cannot be larger than width"
            }
        },
        baseStyleNotAvailableForThisTop: {
            type: 'baseStyleNotAvailableForThisTop',
            severity: 'fatal',
            message: {
                id: "ytoE+w",
                message: "Base Style cannot be applied for this Top"
            }
        },
        baseTypeMustHaveStyles: {
            type: 'baseTypeMustHaveStyles',
            severity: 'fatal',
            message: {
                id: "qUIXvP",
                message: "No bases of this type are available for the chosen tabletop"
            }
        },
        leafAmountNotAvailableForThisLeafType: {
            type: 'leafAmountNotAvailableForThisLeafType',
            severity: 'fatal',
            message: {
                id: "xPahvG",
                message: "Leaf Amount cannot be applied for this Leaf Type"
            }
        },
        lengthMightNotBeAvailableForThisTop: {
            type: 'lengthMightNotBeAvailableForThisTop',
            severity: 'notice',
            message: {
                id: "JYnFoL",
                message: "Tabletop Length"
            }
        },
        widthMaybeTooBigForDoor: {
            type: 'widthMaybeTooBigForDoor',
            severity: 'notice',
            message: {
                id: "n6kfpc",
                message: "The selected width might be too big to fit through a normal door"
            }
        },
        thicknessTypeMightNotBeAvailableForThisTop: {
            type: 'thicknessTypeMightNotBeAvailableForThisTop',
            severity: 'notice',
            message: {
                id: "Qo8UP3",
                message: "Tabletop Thickness"
            }
        },
        customTopFinishNeedsPersonalizedQuote: {
            type: 'customTopFinishNeedsPersonalizedQuote',
            severity: 'notice',
            message: {
                id: "h9u0dy",
                message: "Custom top finish"
            }
        },
        customLeafSizeNeedsPersonalizedQuote: {
            type: 'customLeafSizeNeedsPersonalizedQuote',
            severity: 'notice',
            message: {
                id: "90cdTp",
                message: "Custom leaf size"
            }
        },
        lengthTooShortForDoubleBase: {
            type: 'lengthTooShortForDoubleBase',
            severity: 'fatal',
            message: {
                id: "zs0dLp",
                message: "Length is too short for a double base"
            }
        },
        lengthTooShortForPerimeterOrDropInLeaf: {
            type: 'lengthTooShortForPerimeterOrDropInLeaf',
            severity: 'fatal',
            message: {
                id: "wYGcEf",
                message: "Length is too short for a perimeter or drop in leaf"
            }
        },
        edgeStyleAvailableForThisTop: {
            type: 'edgeStyleAvailableForThisTop',
            severity: 'fatal',
            message: {
                id: "dYVrZP",
                message: "Edge style is not available for this top"
            }
        },
        beveledTopNeverRolled: {
            type: 'beveledTopNeverRolled',
            severity: 'fatal',
            message: {
                id: "BwT9Dh",
                message: "Cannot have a rolled Top with a Beveled Edge Style"
            }
        },
        roundedCorners: {
            type: 'roundedCorners',
            severity: 'fatal',
            message: {
                id: "w/DRlL",
                message: "Round corners are only available on Clean Edged Rectangle or Square tabletops"
            }
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const dataExpressions = implementCustomExpressions({});
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(dataExpressions);

//# sourceMappingURL=implementation.js.map